import { FiChevronDown } from 'react-icons/fi'

import { useTrackerMapContext } from '../TrackerMapContext'
import { type ShipmentFilterValue } from '../types'

// Mirrors the `shipment_status` DB enum, plus 'all'.
const options: { value: ShipmentFilterValue; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'planned', label: 'Planned' },
  { value: 'active', label: 'Active' },
  { value: 'completed', label: 'Completed' },
  { value: 'cancelled', label: 'Cancelled' },
]

// Server-side filter: changing it refetches the summary with ?filter=. 'all'
// also includes trackers with no open shipment.
export const ShipmentFilter = () => {
  const { filters, setFilters } = useTrackerMapContext()

  const handleChange = (value: ShipmentFilterValue) => setFilters({ ...filters, shipment: value })
  const currentLabel = options.find((o) => o.value === filters.shipment)?.label ?? 'Active'

  return (
    <div className="dropdown" data-filter-dropdown>
      <div
        tabIndex={0}
        role="button"
        className="btn btn-sm btn-outline min-w-[160px] flex items-center justify-between font-normal"
      >
        <span>Shipments: {currentLabel}</span>
        <FiChevronDown className="w-4 h-4 text-base-content/60" />
      </div>
      <ul
        tabIndex={0}
        className="dropdown-content menu bg-base-100 rounded-lg shadow-lg border border-base-300 z-20 w-full p-1 mt-1"
      >
        {options.map((opt) => (
          <li key={opt.value}>
            <button
              onClick={() => handleChange(opt.value)}
              className={`text-xs ${filters.shipment === opt.value ? 'active' : ''}`}
            >
              {opt.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
